import React from 'react'
import { getAnalyticsCountryCode } from '@helpers/env'
import styles from './styles.module.scss'

const ICONS = [
  {
    name: 'Visa',
    image: '/static/svgs/payment/visa.svg'
  },
  {
    name: 'MasterCard',
    image: '/static/svgs/payment/mastercard.svg'
  },
  {
    name: 'PayPal',
    image: '/static/svgs/payment/paypal.svg'
  },
  {
    name: 'Amex',
    image: '/static/svgs/payment/amex.svg'
  },
  {
    name: 'Maestro',
    image: '/static/svgs/payment/maestro.svg'
  },
  {
    name: 'ShopifyPay',
    image: '/static/svgs/payment/shop-pay.svg'
  },
  {
    name: 'Klarna',
    image: '/static/svgs/payment/klarna.svg',
    show: ['uk', 'us', 'eu']
  },
  {
    name: 'Sezzle',
    image: '/static/svgs/payment/sezzle.svg',
    show: ['us']
  }
]

const getIcons = () => {
  const allRegionIcons = ICONS.filter(icon => !icon.show)
  const uniqueRegionIcons = ICONS.filter(
    icon => !!icon.show && icon.show.includes(getAnalyticsCountryCode())
  )
  return [...allRegionIcons, ...uniqueRegionIcons]
}

type PaymentCardOptionIconProps = {
  imgSrc: string
  name: string
}
function PaymentCardOptionIcon({ name, imgSrc }: PaymentCardOptionIconProps) {
  return (
    <li className={styles.PaymentCardOptions__item}>
      <img src={`${imgSrc}?w=92`} alt={name} />
    </li>
  )
}

function PaymentCardOptions() {
  const icons = getIcons()
  return (
    <ul className={styles.PaymentCardOptions}>
      {icons.map(({ name, image }) => (
        <PaymentCardOptionIcon name={name} imgSrc={image} key={name} />
      ))}
    </ul>
  )
}

export default PaymentCardOptions
